/* unplugin-vue-components disabled */import { render } from "./LCMain.vue?vue&type=template&id=0bbf7b1c&scoped=true"
import script from "./LCMain.vue?vue&type=script&lang=js"
export * from "./LCMain.vue?vue&type=script&lang=js"

import "./LCMain.vue?vue&type=style&index=0&id=0bbf7b1c&scoped=true&lang=css"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bbf7b1c"]])

export default __exports__